import Module from '../module';
import scroll from '../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			homeStoreContentSectionLeftCls: string;
			homeStoreContentSectionRightCls: string;
		}
	},

	slug: string
}

class Store extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Home Store Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeStoreContentSectionLeftCls || '', 'home_store', { animCls: 'animate__fadeInLeft', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeStoreContentSectionRightCls || '', 'home_store', { animCls: 'animate__fadeInRight', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Store;